import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/webhooks-status")({
  component: lazyRouteComponent(() => import("./-pages/admin.webhooks-status")),
  head: () => ({
    meta: [
      { title: "Webhooks Status · Lecmo Admin" },
      { name: "robots", content: "noindex" },
    ],
  }),
});
